import api from "./api-service";

const baseUrl = "therapists-homologations";

export const getData = () => api().get(`${baseUrl}/therapist`);

export const saveData = (data) => api().post(`${baseUrl}/`, data);
